import i18n from '@/vue-app/plugins/i18n';
import TYPES from '@/types';
import Vue from 'vue';
import { v4 } from 'uuid';

// Domain
import {
  LinkGoalsWealthStateManager,
} from '@/modules/flagship/investor-goal/link-sowos-wealth/domain/state/link-goals-wealth-state-manager';
import {
  StateManager as ContributionsStateManager,
} from '@/modules/my-investment/allianz/recurring-contributions/domain/state/state-manager';
import Inject from '@/modules/shared/domain/di/inject';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class StepSchedulePaymentDateWealthViewModel {
  @Inject(TYPES.LINK_GOALS_WEALTH_STATE_MANAGER)
  readonly link_goals_wealth_state_manager!: LinkGoalsWealthStateManager;

  @Inject(TYPES.ALLIANZ_RECURRING_CONTRIBUTIONS_STATE_MANAGER)
  private readonly contributions_state_manager!:
    ContributionsStateManager;

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier;

  private readonly view!: Vue;

  readonly i18n_namespace = 'components.flagship.flagship-link-goals.step-schedule-payment-date-wealth';

  readonly AVAILABLE_DAYS = [...Array(28).keys()].map((i) => ({ item: `${i18n.t(`${this.i18n_namespace}.select_option`, { option: i + 1 })}`, value: i + 1 }));

  link_goals_wealth_state = this.link_goals_wealth_state_manager.state;

  contributions_state = this.contributions_state_manager.state;

  change_date = true;

  payment_day = 0;

  has_recurring_contributions = true;

  max_contribution = 50000;

  recurring_contribution_id = v4()

  public constructor(view: Vue) {
    this.view = view;
  }

  get disable_btn_continue() {
    return this.link_goals_wealth_state.is_loading || (this.payment_day === 0 && this.change_date);
  }

  translate = (value: string, options?: Record<string, string | number>) => {
    if (options) {
      return i18n.tc(`${this.i18n_namespace}.${value}`, 0, options) as string;
    }
    return i18n.t(`${this.i18n_namespace}.${value}`) as string;
  }

  initialize = async () => {
    this.loadRecurringContributionInformation();
  }

  loadRecurringContributionInformation = () => {
    this.has_recurring_contributions = this.contributions_state.item.home_desired;
    if (this.contributions_state.item.contributions.length === 1) {
      this.link_goals_wealth_state.first_goal_contribution.id = this.contributions_state.item
        .contributions[0].id;
      this.link_goals_wealth_state.first_goal_contribution.collection_day = this.contributions_state
        .item.contributions[0].collection_day;
      this.payment_day = this.contributions_state.item.contributions[0].collection_day;
    } else {
      this.link_goals_wealth_state.first_goal_contribution.id = this.recurring_contribution_id;
      this.link_goals_wealth_state.first_goal_contribution.collection_day = 0;
    }
  };

  updatePaymentDate = async () => {
    let contribution_amount = 0;
    this.link_goals_wealth_state.first_goal_contribution.collection_day = this.payment_day;
    this.link_goals_wealth_state.selected_goals.forEach((selected_goal) => {
      contribution_amount += selected_goal.recurrent_assigned_amount;
      this.link_goals_wealth_state.first_goal_contribution.distributions.push({
        investor_goal_id: selected_goal.investor_goal_id,
        recurrent_assigned_amount: selected_goal.recurrent_assigned_amount.toString(),
      });
    });
    this.link_goals_wealth_state.first_goal_contribution.amount = contribution_amount;
    this.view.$emit('linkGoals');
  }

  goToPrevStep = () => {
    this.view.$emit('prevStep');
    if (this.link_goals_wealth_state.first_goal_contribution.amount <= this.max_contribution
        && this.contributions_state.item.contributions.length < 2) {
      this.view.$emit('prevStep');
    }
  }
}
